
export interface Stream{
    timestamp: number,
    key?: string;
    markdown: string;
}

export function newStream(): Stream{
    let stream: Stream = {
        timestamp: null,
        key: null,
        markdown: null
    }
    return stream;
}


// WEBPACK FOOTER //
// ./src/models/Stream.ts